"use strict";

import React from "react";
import PropTypes from "prop-types";
import { transition, Button } from "reactackle";

export const MenuGroupItem = props => (
  <Button text={props.text} onPress={props.onPress} colorScheme="secondary" />
);



// WEBPACK FOOTER //
// ./src/app/components/Menu/MenuGroupItem/MenuGroupItem.js